const groupPrefix = 'products'

export const apiProducts = {
	fetchSingleProduct: async (productID: number | string) => {
		const { data } = await apiCommon<IProduct>(`${groupPrefix}/${productID}`, { method: 'GET' })
		return Product(data)
	},

	fetchAllProducts: async (filters?: IProductFilter[], perPage?: number) => {
		if (!perPage) perPage = 100
		let url = `${groupPrefix}`
		const queryParams = []

		queryParams.push(`per_page=${perPage}`)

		const filterQueries: string[] = []

		filters?.forEach((filter) => {
			filterQueries.push(`filter[${filter.id}]=${filter.value}`)
		})

		if (filterQueries && filterQueries.length > 0) {
			filterQueries.forEach((query) => {
				queryParams.push(query)
			})
		}

		queryParams.push('sort=segment_sort_order')

		if (queryParams.length > 0) {
			url += `?${queryParams.join('&')}`
		}

		const { data, links } = await apiCommon<IProduct[]>(url, {
			method: 'GET',
		})
		if (!data) return { data: [], links }
		const response = data.map((product) => {
			return Product(product)
		})
		return { data: response, links }
	},

	fetchProductsByParameters: async (
		searches: IProductParameterSearch[],
		filters?: IProductFilter[],
		page?: number,
		perPage?: number,
		sort?: string,
		countPerSegment?: number,
		options?: { signal?: AbortSignal; skipSSRPayload?: boolean; onlyVisible?: boolean },
	) => {
		if (!page) page = 1
		if (!perPage) perPage = 100
		let url = `${groupPrefix}/search`
		const queryParams = []

		queryParams.push(`per_page=${perPage}`)
		queryParams.push(`page=${page}`)

		const filterQueries: string[] = []

		filters?.forEach((filter) => {
			filterQueries.push(`filter[${filter.id}]=${filter.value}`)
		})

		if (filterQueries && filterQueries.length > 0) {
			filterQueries.forEach((query) => {
				queryParams.push(query)
			})
		}

		queryParams.push(`sort=${sort ?? 'segment_sort_order'}`)

		if (countPerSegment) queryParams.push(`count_per_segment=${countPerSegment}`)

		// Without is_visible the API returns hidden cars too
		if (options?.onlyVisible ?? true) queryParams.push('is_visible=true')

		if (queryParams.length > 0) {
			url += `?${queryParams.join('&')}`
		}

		const { data, links, meta } = await apiCommon<IProduct[]>(url, {
			method: 'POST',
			body: { searches },
			signal: options?.signal,
			skipSSRPayload: options?.skipSSRPayload ?? false,
		})
		if (!data) return { response: [], links, meta: null }
		const response = data.map((product) => {
			return Product(product)
		})
		return { response, links, meta: meta ?? null }
	},

	// fetchProductsByParametersClient: async (searches: IProductParameterSearch[], page?: number, perPage?: number) => {
	// 	if (!page) page = 1
	// 	if (!perPage) perPage = 100
	// 	const url = `${groupPrefix}/search?page=${page}&per_page=${perPage}`
	// 	const { data, links } = await apiCommon<IProduct[]>(url, {
	// 		method: 'POST',
	// 		body: { searches },
	// 	})
	// 	if (!data) return { response: [], links }
	// 	const response = data.map((product) => {
	// 		return Product(product)
	// 	})
	// 	return { response, links }
	// },

	fetchProductsByQuery: async (page: number = 1, perPage: number = 10, name?: string) => {
		const url = name ? `${groupPrefix}/search?page=${page}&per_page=${perPage}&name=${name}` : `${groupPrefix}?page=${page}&per_page=${perPage}`
		const { data, links } = await apiCommon<IProduct[]>(url, {
			method: 'GET',
		})
		if (!data) return { response: [], links }
		const response = data.map((product) => {
			return Product(product)
		})
		return { response, links }
	},

	updateProduct: async (productID: string, segmentID: string | number, parameters: IProductParameterSend[], isVisible: boolean | null) => {
		const { data } = await apiCommon<IProduct>(`${groupPrefix}/${productID}`, {
			method: 'PUT',
			body: { parameters, segment_id: segmentID, is_visible: isVisible },
		})
		return Product(data)
	},
}
